import { render } from "./DescriptionList.vue?vue&type=template&id=18df1aea&scoped=true"
import script from "./DescriptionList.vue?vue&type=script&lang=js"
export * from "./DescriptionList.vue?vue&type=script&lang=js"

import "./DescriptionList.vue?vue&type=style&index=0&id=18df1aea&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18df1aea"]])

export default __exports__